import React from 'react'
import { classNames } from '../../../utils/classNames'

const TemplateInvitation = ({
	headerTitle,
	title,
	titlePrefix,
	description,
	maxSteps,
	currentStep,
	onNextClickEvent,
	onSkip,
	children
}: {
	headerTitle: string,
	titlePrefix: string,
	title: string,
	description: string,
	maxSteps: number,
	currentStep: number,
	onSkip?: () => void,
	onNextClickEvent: () => void,
	children: React.ReactElement
}) => {
	return (
		<div className='font-inter w-full xl:w-[760px] mx-auto mt-5 md:mt-12 '>
			<div className='flex flex-wrap'>
				<div className='w-full md:w-10/12'>
					<h4 className='text-sm text-opacityTitle mb-1'>
						{headerTitle}
					</h4>
					<div className='flex flex-wrap'>
						<div className='flex flex-row py-2'>
							{Array(maxSteps).fill(0).map((_e, index: number)=> (
								<div key={index} className={classNames('w-7 h-2.5 rounded-3xl mr-1', currentStep >= index + 1 ? 'bg-primary-default' : 'bg-inactive')} />
							))}
						</div>
						<div>
							{onSkip && <button onClick={onSkip} className='ml-5 text-primary-default font-normal text-sm md:text-lg underline' type='button'>
								Skip
							</button>}
						</div>
					</div>
					
					<h2 className='text-2xl md:text-5xl font-medium mb-3'>
						<span className='font-bold mr-2'>{titlePrefix}</span>
						{title}
					</h2>
					<p className='font-normal text-sm md:text-xl'>{description}</p>
				</div>
				<button onClick={onNextClickEvent} className='ml-auto bg-primary-default rounded-xl px-4 py-2 text-lg text-white h-12 hover:bg-opacity-90 mt-5 md:mt-14' type='button'>
					Next
				</button>
			</div>
			<div className='my-5'>
				{children}
			</div>
		</div>
	)
}

export default TemplateInvitation;